import { useState, useCallback } from "react";

type UseDontShowAgainReturn = {
  dontShowAgain: boolean;
  setDontShowAgain: (value: boolean) => void;
  handleClose: (
    onPermanentHide: () => void,
    onTemporaryHide: () => void,
    onClose: () => void
  ) => void;
};

const useDontShowAgain = (): UseDontShowAgainReturn => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  /**
   * Handle close action based on dontShowAgain state
   * @param onPermanentHide - Called when checkbox is checked (permanent hide until CRM update)
   * @param onTemporaryHide - Called when checkbox is not checked (24-hour hide)
   * @param onClose - Called to close the popup
   */
  const handleClose = useCallback(
    (
      onPermanentHide: () => void,
      onTemporaryHide: () => void,
      onClose: () => void
    ) => {
      if (dontShowAgain) {
        onPermanentHide();
      } else {
        onTemporaryHide();
      }
      onClose();
    },
    [dontShowAgain]
  );

  return {
    dontShowAgain,
    setDontShowAgain,
    handleClose,
  };
};

export default useDontShowAgain;
